import { useEffect, useState } from "react";
import { previewDocuments } from "./pbreader/pdfPreviewDocuments";
import { getDocumentFileUrl } from "../../utils/documentFiles";

// Фоновый анализ документов заказа (ориентация, пустые страницы — см.
// pageAnalysis.js). По одному документу за раз, выбранный — первым: его
// ориентацию человек видит в превью прямо сейчас.
//
// → { [docId]: { pageCount, landscape, blankPages? } | null }; null — анализ
// не удался, повторно не пробуем (оплату это не блокирует, просто не будет
// автоориентации и предупреждения).
//
// findBlank — искать ли пустые страницы (флаг аппарата из админки);
// undefined — настройки аппарата ещё не пришли, ждём. Флаг включили уже
// после анализа — документ анализируется заново, уже с поиском.
export default function useDocumentAnalysis(documents, priorityId, findBlank) {
    const [analysis, setAnalysis] = useState({});
    const ordered = [...documents].sort((a, b) => (b.id === priorityId) - (a.id === priorityId));
    const needsRun = (doc) =>
        !(doc.id in analysis) || (findBlank && analysis[doc.id] && !("blankPages" in analysis[doc.id]));
    const pending = findBlank === undefined ? null : ordered.find(needsRun) || null;

    useEffect(() => {
        if (!pending) return undefined;
        const docId = pending.id;
        const token = localStorage.getItem("access_token");
        let live = true;
        const finish = (result) => {
            if (live) setAnalysis((prev) => ({ ...prev, [docId]: result }));
        };

        if (window.electronAPI?.pbreader) {
            // Тот же документ пула, что у превью: PDF не качается второй раз,
            // а анализ запоминается на записи (pdfPreviewDocuments.js), так что
            // смена таба посреди анализа его не перезапускает.
            const lease = previewDocuments.acquire(docId, token, 0);
            lease.promise
                .then((record) => (record.analyze ? record.analyze(findBlank) : null))
                .then(finish, () => finish(null))
                .finally(() => lease.release());
            return () => { live = false; lease.release(); };
        }

        import("./browser/analyzeBrowserDocument")
            .then(({ analyzeBrowserDocument }) =>
                analyzeBrowserDocument(getDocumentFileUrl(pending), token, { findBlank, isCancelled: () => !live }))
            .then(finish, () => finish(null));
        return () => { live = false; };
    }, [pending, findBlank]);

    return analysis;
}
